import { Button, Form, Input, message } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { AuthService } from "@services/auth.service";
import { useCallback, useEffect, useState } from "react";
import { AndroidDataEventMap } from "@declarations/event";
import { androidLoginBiometric } from "@utils/android";
import { NoticeType } from "antd/es/message/interface";

export const LoginPage = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm<{ username: string; password: string }>();
  const [messageApi, contextHolder] = message.useMessage();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");

  const listener = useCallback(
    (ev: MessageEvent<AndroidDataEventMap["on-login-biometric"]>) => {
      form.setFieldsValue(ev.data);
      form.submit();
    },
    [form],
  );

  useEffect(() => {
    const requestBiometric = setTimeout(() => {
      androidLoginBiometric();
    }, 500);
    window.addEventListener("on-login-biometric", listener);

    return () => {
      clearTimeout(requestBiometric);
      window.removeEventListener("on-login-biometric", listener);
    };
  }, [listener]);
  // const {
  //   register,
  //   handleSubmit,
  //   formState: { errors },
  // } = useForm<AuthLogin>({
  //   resolver: yupResolver<AuthLogin>(authLoginSchema),
  // });

  const { mutate, isPending } = useMutation({
    mutationFn: AuthService.login,
    onSuccess: (response) => {
      if (response.success) {
        navigate(response.data!.redirect);
      } else {
        setShowMessage(true);
        setMessageType("error");
        setShowMessageText(response.message);
      }
    },
  });

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText, messageType, messageApi]);

  return (
    <>
      {contextHolder}
      {/* <div className="bg-semi-circle bg-gradient tw-h-[550px]">
        <svg
          className="curve"
          viewBox="0 0 100 12"
          preserveAspectRatio="none"
          style={{
            position: "absolute",
            bottom: "-1px",
            left: "0",
            width: "100%",
            height: "100px",
          }}
        >
          <path d="M0,0 Q50,3 100,0 L100,30 L0,30 Z" fill="#f9f9fb" />
        </svg>
      </div> */}
      <div className="tw-rounded-t-[40px] tw-pt-3 tw-px-8 tw-pb-8 tw-mt-[-35px] tw-flex-1 bg-gradient">
        {/* Handle indicator */}
        <div className="tw-flex tw-justify-center tw-mb-6">
          <div
            className="tw-w-10 tw-h-1 tw-rounded-full"
            style={{ background: "rgba(255,255,255,0.35)" }}
          />
        </div>
        <div className="tw-mb-1 tw-text-2xl tw-font-semibold tw-text-white tw-text-center">
          Tarbiyatus Shibyan
        </div>
        <div className="tw-text-xs tw-text-white/70 tw-text-center tw-mb-8">
          Silakan masukkan data Anda
        </div>
        <Form name="basis" layout="vertical" onFinish={(data) => mutate(data)}>
          <Form.Item
            name="username"
            rules={[{ required: true, message: "NIS tidak boleh kosong!" }]}
          >
            <Input
              prefix={<UserOutlined style={{ color: "#22c55e" }} />}
              className="tw-shadow-none tw-text-base tw-bg-white tw-rounded-xl tw-border-0"
              placeholder="NIS/Nomor Induk Siswa"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Password tidak boleh kosong!" },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: "#22c55e" }} />}
              className="tw-shadow-none tw-text-base tw-bg-white tw-rounded-xl tw-border-0"
              placeholder="Password"
            />
          </Form.Item>

          <Form.Item className="tw-w-full tw-mb-8 tw-mt-10">
            <Button
              className="tw-h-11 tw-w-full tw-block tw-mx-auto tw-text-base tw-font-semibold tw-text-primary tw-rounded-xl tw-bg-white tw-border-0 focus:tw-shadow-none"
              htmlType="submit"
              loading={isPending}
            >
              Masuk
            </Button>
          </Form.Item>
        </Form>
        <div
          className="tw-mb-8"
          style={{ borderBottom: "1px solid rgba(255,255,255,0.2)" }}
        />
        <div className="tw-text-sm tw-text-white/70 tw-text-center">
          Silahkan hubungi{" "}
          <span className="tw-text-white tw-font-bold">Admin</span> jika terjadi
          masalah terhadap aplikasi
        </div>
      </div>
    </>
  );
};
